export const ORDER_SUMMARY_CONSTANTS = {
    VIEW_FULL_BASKET: 'View Full Basket',
    CHECKOUT: 'Checkout',
    TOTAL: 'Total:',
    TAX_APPLIED: '+ tax applied at checkout',
};
